import Link from "next/link";
import { EquipmentItem } from "../../types/menu.types";

interface EquipmentListProps {
  items: EquipmentItem[];
  onClose: () => void;
}

export const EquipmentList = ({ items, onClose }: EquipmentListProps) => (
  <ul role="list" aria-labelledby="brand-heading" className="space-y-6 sm:space-y-7 w-full">
    {items.map((item, i) => (
      <li className="flow-root" key={i}>
        <Link href={item.href}>
          <div
            onClick={onClose}
            className="min-w-full -m-3 p-3 flex items-center space-x-4 rounded-md text-base leading-6 font-medium text-gray-900 hover:bg-gray-100 transition ease-in-out duration-150"
          >
            {item.icon && <item.icon className="flex-shrink-0 h-6 w-6 text-gray-400" />}
            {item.svg && item.svg}
            <span className="text-sm font-medium text-gray-900">{item.name}</span>
          </div>
        </Link>
      </li>
    ))}
  </ul>
); 